import { posts } from '../../../content/career/cards';
import * as React from 'react';
import { cx } from '../../../components/CareerLayout/styles';
import * as media from '../../../assets/career/media';
import { CareerBlog } from '../../../components/CareerLayout/CareerBlog';

export const Blog: React.FC = () => (
  <section className={cx('main_section_blog')}>
    <div className={cx('padding-global padding-section-medium')}>
      <div className={cx('container-large')}>
        <div className={cx('main_content_blog')}>
          <div className={cx('main_blog_h2-wrapper')}>
            <h2>
              <span className={cx('text-style-lowercase text-color-brand-blue')}>
                {'ДВИГАЕМ '}
                <br />
                {'Tech'}
              </span>
              {' и не только'}
            </h2>
            <img
              src={media.mainBlogBikeImage}
              loading="lazy"
              sizes="100vw"
              srcSet={[
                media.mainBlogBikeImageP500 + ' 500w',
                media.mainBlogBikeImageP800 + ' 800w',
                media.mainBlogBikeImage + ' 1095w',
              ].join(', ')}
              alt=""
              className={cx('main_blog_bike-image')}
            />
          </div>
          <div className={cx('spacer-large')}></div>
          <CareerBlog>
            {posts.map(post => (
              <article key={post.href} className={cx('main_blog_card')}>
                <div className={cx('main_blog_card-top')}>
                  <div className={cx('main_blog_image-wrapper')}>
                    <img
                      src={post.image}
                      srcSet={post.srcSet}
                      sizes="(max-width: 479px) 100vw, (max-width: 991px) 50vw, 33vw"
                      loading="lazy"
                      alt=""
                      className={cx('main_blog_image')}
                    />
                  </div>
                  <div className={cx('main_blog_text')}>
                    <div className={cx('main_blog_info-wrapper')}>
                      <div>{post.source}</div>
                      <div>{post.duration}</div>
                    </div>
                    <div className={cx('spacer-tiny')} />
                    <h3 className={cx('text-size-xregular')}>{post.title}</h3>
                  </div>
                </div>
                <a href={post.href} target="_blank" rel="noopener noreferrer" className={cx('button is-white-on-blue')}>
                  {post.action}
                </a>
              </article>
            ))}
          </CareerBlog>
          <div className={cx('spacer-xlarge')}></div>
        </div>
      </div>
    </div>
  </section>
);
